// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useContext, useEffect, useState } from "react";
import * as React from "react";
import { infoProps } from "@store/Themes/common/props/info";
import AlertTriangleFill from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";

export interface OrderDetailsCarrierStyles {
    titleText?: TypographyPresentationProps;
    carrierText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    changeTooltipAlert?: TooltipPresentationProps;
}

export const carrierStyles: OrderDetailsCarrierStyles = {
    titleText: infoProps.label,
    carrierText: infoProps.value,
    changeTooltipAlert: {
        iconProps: {
            color: "warning",
            src: AlertTriangleFill,
        },
    },
};
const styles = carrierStyles;

const OrderDetailsCarrier = () => {
    const { value: order } = useContext(OrderStateContext);
    const [orderChangePropriety, setOrderChangePropriety] = useState<any>();

    useEffect(() => {
        if (order?.properties.orderChanges) {
            setOrderChangePropriety(JSON.parse(order?.properties.orderChanges));
        }
    }, [order?.properties.orderChanges]);

    if (!order || !order.properties.carrier) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.titleText}>
                {translate("Carrier")}
            </Typography>
            <Typography {...styles.carrierText}>
                {order.properties.carrierDescription}
                {orderChangePropriety?.carrier && orderChangePropriety?.carrier !== order.properties.carrier && (
                    <Tooltip
                        text={translate(
                            `Carrier has been updated from {0} to {1}`,
                            orderChangePropriety?.carrier,
                            order.properties.carrier,
                        )}
                        {...styles.changeTooltipAlert}
                    />
                )}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsCarrier,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
